import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, fmtQty, fmtDT } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, StatusBadge, Empty, tableWrap, th, td, num } from "@/components/common";

export const lineTotals = (lines) => {
  const t = {};
  lines.forEach((l) => { t[l.unit] = (t[l.unit] || 0) + l.quantity; });
  return Object.entries(t).map(([u, v]) => fmtQty(v, u)).join(" · ");
};

export default function InwardList() {
  const { can } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/inwards", { params: { q } }).then((r) => setItems(r.data)); }, [q]);
  return (
    <div>
      <PageHeader title="Stock Inward" subtitle="Supplier receipts. Physical stock increases only when an entry is posted by an authorised manager.">
        {can("inward:create") && <Button onClick={() => nav("/inward/new")} data-testid="inward-new-btn"><Plus className="h-4 w-4 mr-1" />New inward entry</Button>}
      </PageHeader>
      <Input placeholder="Search inward no, invoice, supplier, drum, PO…" value={q} onChange={(e) => setQ(e.target.value)} className="sm:max-w-md mb-4" data-testid="inward-search-input" />
      <div className={tableWrap}>
        <table className="w-full" data-testid="inward-table">
          <thead><tr>{["Inward No", "Date", "Supplier", "Invoice", "PO", "Lines", "Quantity", "Entered By", "Status", "Created"].map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
          <tbody>{items.map((i) => (
            <tr key={i.id} className="hover:bg-muted/40" data-testid={`inward-row-${i.inward_no}`}>
              <td className={`${td} font-mono`}><Link to={`/inward/${i.id}`} className="underline-offset-4 hover:underline font-medium" data-testid={`inward-link-${i.inward_no}`}>{i.inward_no}</Link></td>
              <td className={td}>{i.date}</td><td className={td}>{i.supplier_name}</td><td className={`${td} font-mono`}>{i.invoice_no}</td><td className={td}>{i.po_no}</td>
              <td className={`${td} ${num}`}>{i.lines.length}</td><td className={`${td} ${num}`}>{lineTotals(i.lines)}</td><td className={td}>{i.entered_by.name}</td>
              <td className={td}><StatusBadge status={i.status} /></td><td className={td}>{fmtDT(i.created_at)}</td>
            </tr>
          ))}</tbody>
        </table>
        {!items.length && <Empty text="No inward entries yet" />}
      </div>
    </div>
  );
}
